import $ from 'jquery';
import _ from 'lodash';
import { enableTouch } from '../../utilities/tabletUtil';

import { getNextDay, getPrevDay } from './works';
import { isIPad } from '../../utilities/commonUtil';

//ドロップダウンメニューを作成
export function DropdownCalendar() {}

DropdownCalendar.prototype.init = function(id, input, fieldId) {
  const self = this;
  self.calendar_id = id;
  self.calendar = $(`#${id}`);
  self.input = $(`#${id} ${input}`);
  self.calDate = self.input.val() ? new Date(self.input.val()) : new Date();
  self.selectDate = self.input.val() ? new Date(self.input.val()) : new Date();
  self.calendar.find('.dropdown-calender__calender').html(self.getBase());
  self.fieldId = fieldId;
  self.addEvent();
};

DropdownCalendar.prototype.addClickOrTouch = function(element, fn) {
  const eventName = !enableTouch() ? 'click' : 'touchstart';
  element.on(eventName, function(e) {
    fn(e);
  });
};

DropdownCalendar.prototype.addEvent = function() {
  const self = this;
  this.addClickOrTouch(self.input, function() {
    self.showCalendar();
    /**
     *  iPad safariのz-index不具合対応
     *  6分割、9分割時、画面右下のカレンダーを開いた際
     *  カレンダーが隠れないようツールバーを非表示にする
     */
    if (
      (self.calendar_id === 'dropdown-calendar-split-8' ||
        self.calendar_id === 'dropdown-calendar-split-5') &&
      isIPad()
    ) {
      $('.layout-tool-footer').hide();
    }
  });
  this.addClickOrTouch($(document), function(e) {
    if (self.calendar.hasClass('show')) {
      if (!$(e.target).closest(self.calendar).length) {
        self.hideCalendar();
        if (
          (self.calendar_id === 'dropdown-calendar-split-8' ||
            self.calendar_id === 'dropdown-calendar-split-5') &&
          isIPad()
        ) {
          $('.layout-tool-footer').show();
        }
      } else {
        event.preventDefault();
      }
    }
  });

  // カレンダー部 上ボタン 翌日
  this.addClickOrTouch(
    self.calendar.find('.sys-calender-day-down'),
    function() {
      self.prevDate();
    }
  );

  // カレンダー部 下ボタン 前日
  this.addClickOrTouch(self.calendar.find('.sys-calender-day-up'), function() {
    self.nextDate();
  });

  // カレンダーポップアップ 月 左ボタン
  this.addClickOrTouch(self.calendar.find('.sys-prev-month'), function() {
    self.addMonth(-1);
  });

  // カレンダーポップアップ 月 右ボタン
  this.addClickOrTouch(self.calendar.find('.sys-next-month'), function() {
    self.addMonth(1);
  });

  // カレンダーポップアップ 選択 ボタン
  this.addClickOrTouch(self.calendar.find('.sys-submit'), function() {
    self.setSelectDate();
  });
};

DropdownCalendar.prototype.showCalendar = function() {
  const self = this;
  self.calDate = self.input.val() ? new Date(self.input.val()) : new Date();
  self.selectDate = self.input.val() ? new Date(self.input.val()) : new Date();
  self.setPopup();
  self.calendar.addClass('show');
};

/**
 * 指定日付分を加えて日付を変更する
 */
// DropdownCalendar.prototype.addDate = function(num) {
//   const self = this;
//   self.selectDate = self.input.val() ? new Date(self.input.val()) : new Date();
//   self.selectDate.setDate(self.selectDate.getDate() + num);
//   self.setSelectDate();
// };

/**
 * 稼働日前日に移動する
 */
DropdownCalendar.prototype.prevDate = async function() {
  const self = this;
  self.selectDate = await getPrevDay(
    self.fieldId,
    self.input.val() ? new Date(self.input.val()) : new Date()
  );
  self.setSelectDate();
};

/**
 * 稼働日翌日に移動する
 */
DropdownCalendar.prototype.nextDate = async function() {
  const self = this;
  self.selectDate = await getNextDay(
    self.fieldId,
    self.input.val() ? new Date(self.input.val()) : new Date()
  );
  self.setSelectDate();
};

// eslint-disable-next-line no-unused-vars
DropdownCalendar.prototype.addMonth = function(num) {
  const self = this;
  self.calDate.setDate(1); // 月の始めの日に変更する
  self.calDate.setMonth(self.calDate.getMonth() + num);
  self.setPopup();
};

DropdownCalendar.prototype.checkDate = function(input) {
  const self = this;
  if ($(input).prop('checked')) {
    self.selectDate = new Date($(input).val());
  }
  _.each(self.calendar.find('.sys-calendar-date'), function(checkbox) {
    if ($(checkbox).attr('id') != $(input).attr('id')) {
      $(checkbox).prop('checked', false);
    }
  });
};

DropdownCalendar.prototype.setSelectDate = function() {
  const self = this;
  let datetime = self.selectDate;
  let year = datetime.getFullYear();
  let month = datetime.getMonth() + 1;
  let date = datetime.getDate();
  self.setValue(`${year}/${`0${month}`.slice(-2)}/${`0${date}`.slice(-2)}`);
  self.hideCalendar();
  $('.layout-tool-footer').show();
};

DropdownCalendar.prototype.setPopup = function() {
  const self = this;
  const datetime = self.calDate;
  const year = datetime.getFullYear();
  const month = datetime.getMonth() + 1;

  // eslint-disable-next-line
  const date = datetime.getDate();

  self.calendar
    .find('.sys-calender-title')
    .html(`${year} / ${`0${month}`.slice(-2)}`);
  const dateList = self.getCalendarDate(year, month, self.selectDate);
  let calendar = self.getCalendar(dateList);
  self.calendar.find('.sys-calender-body').html(calendar);
  self.addClickOrTouch(self.calendar.find('.calender-day'), function(e) {
    let check = $(e.target).find('.sys-calendar-date');
    $(check).prop('checked', !$(check).prop('checked'));
    self.checkDate(check);
  });
};

DropdownCalendar.prototype.getCalendar = function(dateList) {
  return dateList.map(function(weekRow, rowIndex) {
    return `<tr class="calender__week sys-row${rowIndex}">${
      // eslint-disable-next-line
      weekRow.map(function(date, dateIndex) {
        if (date.key >= 0) {
          return (
            `${'' + '<td class="calender__day">' + '<label id="click-'}${
              date.date
            }" for="calender-${date.date}" class="calender-day select">` +
            `<input` +
            ` id="calender-${date.date}"` +
            ` type="checkbox" class="sys-calendar-date"` +
            ` value="${date.year}/${date.month}/${date.date}"${
              date.today ? ' checked' : ' '
            } />` +
            `<div class="calender-day__number">${date.date}</div>` +
            `</label>` +
            `</td>`
          );
        } else {
          return (
            '' +
            '<td class="calender__day">' +
            '<label id="click--" for="calender--" class="calender-day">' +
            '<div class="calender-day__number">-</div>' +
            '</label>' +
            '</td>'
          );
        }
      })
    }</tr>`;
  });
};

DropdownCalendar.prototype.getCalendarDate = function(
  currentYear,
  currentMonth,
  today
) {
  const startDate = new Date(`${currentYear}/${currentMonth}/01`);
  const month = startDate.getMonth();
  const date = new Date(`${currentYear}/${currentMonth}/01`);
  const calender = [];
  let week = [];
  // 1日までは空白
  for (let wd = 0; wd < date.getDay(); wd++) {
    week.push({});
  }
  // 日付を設定
  while (date.getMonth() === month) {
    let todayFlg = false;
    if (date.getDay() === 0 && date.getDate() !== 1) {
      calender.push(week);
      week = [];
    }
    if (
      today.getFullYear() === date.getFullYear() &&
      today.getMonth() === date.getMonth() &&
      today.getDate() === date.getDate()
    ) {
      todayFlg = true;
    }
    week.push({
      key: date.getDate() - 1,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      date: date.getDate(),
      day: date.getDay(),
      today: todayFlg,
    });
    date.setDate(date.getDate() + 1);
  }
  // 末日後は土曜日まで空白とする
  if (date.getDay() !== 0) {
    for (let wd = date.getDay(); wd <= 6; wd++) {
      week.push({});
    }
  }
  calender.push(week);
  return calender;
};

DropdownCalendar.prototype.getBase = function() {
  return (
    '' +
    '<div class="popup-calender">' +
    '<div class="popup-calender__header"></div>' +
    '<div class="popup-calender__calender">' +
    '<div class="calender-header calender-header--popup-calender ">' +
    '<div class="calender-header__prev-month sys-prev-month">' +
    '<button class="btn-icon">' +
    '<i class="i-arrow-left i-2x"></i>' +
    '</button>' +
    '</div>' +
    '<div class="calender-header__title sys-calender-title"></div>' +
    '<div class="calender-header__next-month sys-next-month">' +
    '<button class="btn-icon">' +
    '<i class="i-arrow-right i-2x"></i>' +
    '</button>' +
    '</div>' +
    '</div>' +
    '<table class="calender calender--popup-calender">' +
    '<thead>' +
    '<tr class="calender__label">' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-0" class="calender-label">' +
    '<div class="calender-label__day">日</div>' +
    '</label>' +
    '</th>' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-1" class="calender-label">' +
    '<div class="calender-label__day">月</div>' +
    '</label>' +
    '</th>' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-2" class="calender-label">' +
    '<div class="calender-label__day">火</div>' +
    '</label>' +
    '</th>' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-3" class="calender-label">' +
    '<div class="calender-label__day">水</div>' +
    '</label>' +
    '</th>' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-4" class="calender-label">' +
    '<div class="calender-label__day">木</div>' +
    '</label>' +
    '</th>' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-5" class="calender-label">' +
    '<div class="calender-label__day">金</div>' +
    '</label>' +
    '</th>' +
    '<th class="calender__day">' +
    '<label for="sys-select-col-6" class="calender-label">' +
    '<div class="calender-label__day">土</div>' +
    '</label>' +
    '</th>' +
    '</tr>' +
    '</thead>' +
    '<tbody class="sys-calender-body">' +
    '</tbody>' +
    '</table>' +
    '</div>' +
    '<div class="popup-calender__footer">' +
    '<button class="btn--sm--stay sys-submit">選択</button>' +
    '</div>' +
    '</div>'
  );
};

DropdownCalendar.prototype.hideCalendar = function() {
  const self = this;
  self.calendar.removeClass('show');
};

DropdownCalendar.prototype.setValue = function(val) {
  const self = this;
  self.input.val(val).change();
};



// WEBPACK FOOTER //
// ./src/canvas/common/DropDownCalendar.js